/**
 * Format a USD run cost for display.
 *
 * The old `toFixed(4)` rendered every cost as `$0.0000`-style — noisy for zero and
 * misleading for tiny amounts. This normalises to a friendly `$0.00` for ordinary
 * amounts while still signalling a real-but-sub-cent cost:
 *
 *   0                → `$0.00`   (a genuine zero — no cost recorded yet)
 *   0 < cost < 0.01  → `< $0.01` (a real cost too small to show at 2 decimals)
 *   cost ≥ 0.01      → `$1.23`   (two decimals)
 *
 * Non-finite / negative inputs collapse to `$0.00` (defensive — cost is never negative).
 */
export function formatCost(costUsd: number): string {
  if (!Number.isFinite(costUsd) || costUsd <= 0) return '$0.00';
  if (costUsd < 0.01) return '< $0.01';
  return `$${costUsd.toFixed(2)}`;
}
